<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Historial de cuentas por cobrar aseguradoras
    </h2>
    <MainListOfInsuranceAccountsReceivable />
  </div>
</template>

<script>
import MainListOfInsuranceAccountsReceivable from "@/components/Sales/InsuranceAccountsReceivable/ListOfInsuranceAccountsReceivable/MainListOfInsuranceAccountsReceivable.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ListOfInsuranceAccountsReceivable",
  components: {
    MainListOfInsuranceAccountsReceivable,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
